import { isAxiosError } from 'axios';

export const isNotFoundError = (error: unknown): boolean => isAxiosError(error) && error.response?.status === 404;

export const returnIfNotFoundError = <T>(error: unknown, fallbackResult: T): T => {
  if (isNotFoundError(error)) return fallbackResult;

  throw error;
};
